module.exports = "../../app/cells/components/subproduct_landings/features_cell.rb";